var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnimation = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 292,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "big-hex"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M267.788 72.7528L209.683 183.911M20.2118 74.0056L144.001 80.3214M20.2118 72.7528L78.3171 183.911M267.788 73.8011L143.999 80.3267M78.3155 183.898L144 290.003L209.684 183.898M19.2925 74.5095V217.502C19.2925 217.814 19.4588 218.102 19.7288 218.258L143.564 289.754C143.834 289.91 144.166 289.91 144.436 289.754L268.271 218.258C268.541 218.102 268.708 217.814 268.708 217.502V74.5095C268.708 74.1977 268.541 73.9096 268.271 73.7537L144.436 2.25755C144.166 2.10165 143.834 2.10165 143.564 2.25754L19.7288 73.7537C19.4588 73.9096 19.2925 74.1977 19.2925 74.5095Z",
    stroke: "#254250",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M267.788 216.734L209.683 183.892M20.2117 216.734L78.3169 183.892M79.5938 182.631L144.015 150.872V80.3153M144 80.1403V4.53125M144 284.772V148.531M21.4901 74L142.753 151.053M266.537 75.2528L142.747 151.042M208.432 182.643L144.011 150.884",
    stroke: "#254250",
    strokeWidth: 2.6,
    strokeLinejoin: "round",
    strokeDasharray: "6.55 6.55"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 144.36,
    cy: 14.6079,
    r: 10.1782,
    fill: "#FC5200"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "14.6079;270.6079;270.6079;14.6079",
    keyTimes: "0;0.4;0.42;1",
    dur: "5s",
    begin: "-4.5s",
    repeatCount: "indefinite"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 292,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 292",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "big-hex"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M267.788 72.7528L209.683 183.911M20.2118 74.0056L144.001 80.3214M20.2118 72.7528L78.3171 183.911M267.788 73.8011L143.999 80.3267M78.3155 183.898L144 290.003L209.684 183.898M19.2925 74.5095V217.502C19.2925 217.814 19.4588 218.102 19.7288 218.258L143.564 289.754C143.834 289.91 144.166 289.91 144.436 289.754L268.271 218.258C268.541 218.102 268.708 217.814 268.708 217.502V74.5095C268.708 74.1977 268.541 73.9096 268.271 73.7537L144.436 2.25755C144.166 2.10165 143.834 2.10165 143.564 2.25754L19.7288 73.7537C19.4588 73.9096 19.2925 74.1977 19.2925 74.5095Z",
    stroke: "#254250",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M267.788 216.734L209.683 183.892M20.2117 216.734L78.3169 183.892M79.5938 182.631L144.015 150.872V80.3153M144 80.1403V4.53125M144 284.772V148.531M21.4901 74L142.753 151.053M266.537 75.2528L142.747 151.042M208.432 182.643L144.011 150.884",
    stroke: "#254250",
    strokeWidth: 2.6,
    strokeLinejoin: "round",
    strokeDasharray: "6.55 6.55"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 144.36,
    cy: 14.6079,
    r: 10.1782,
    fill: "#FC5200"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "14.6079;270.6079;270.6079;14.6079",
    keyTimes: "0;0.4;0.42;1",
    dur: "5s",
    begin: "-4.5s",
    repeatCount: "indefinite"
  })))));
});
export default SvgAnimation;
export const raw = __webpack_public_path__ + "static/media/animation.4186a3e4194159ff49ca89efab0da42a.svg";